<template>
  <div class="container mt-2 basic-info">
    <div class="col-md">
      <div class="card">
        <div class="card-body">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-6">
                <h5 class="float-start card-title">Basic Information</h5>
              </div>
              <div class="col-md-6">
                <div
                  v-show="
                    permission.includes('basic-information-edit') === true
                  "
                >
                  <i
                    class="float-end bi bi-pencil-square"
                    data-bs-toggle="modal"
                    data-bs-target="#basicInfoEditModal"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div
              v-for="personalInfo in personalInfo"
              :key="personalInfo.user_code"
            >
              <div class="row">
                <div class="col-md-4">
                  <span>Name</span>
                  <p>{{ personalInfo.name }}</p>

                  <span>Registration on:</span>
                  <p>
                    {{
                      personalInfo.registation
                        ? personalInfo.registation
                        : 'N/A'
                    }}
                  </p>

                  <span>No of Trips:</span>
                  <p>
                    {{
                      personalInfo.totalTrip ? personalInfo.totalTrip : 'N/A'
                    }}
                  </p>
                </div>
                <div class="col-md-4">
                  <span>Contact No.</span>
                  <p>{{ personalInfo.mobile ? personalInfo.mobile : 'N/A' }}</p>

                  <span>bKash No.</span>
                  <p>
                    {{ personalInfo.bkashNo ? personalInfo.bkashNo : 'N/A' }}
                  </p>

                  <span>Date of Birth</span>
                  <p>
                    {{
                      personalInfo.birthDate ? personalInfo.birthDate : 'N/A'
                    }}
                  </p>
                </div>
                <div class="col-md-4">
                  <span>Email</span>
                  <p>{{ personalInfo.email ? personalInfo.email : 'N/A' }}</p>

                  <span>Partner Type</span>
                  <p>
                    {{
                      personalInfo.partnerType
                        ? personalInfo.partnerType
                        : 'N/A'
                    }}
                  </p>

                  <span>NID</span>
                  <p>{{ personalInfo.nid ? personalInfo.nid : 'N/A' }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="basicInfoEditModal"
    tabindex="-1"
    aria-labelledby="addRemarksLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addRemarksLabel">Edit Basic Info</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="container">
            <form @submit.prevent="updateBasicInformation">
              <div class="col">
                <div class="mb-3">
                  <label for="Name" class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="User Name"
                    id="driverName"
                    v-model="this.basicInformation.name"
                  />
                </div>
                <div class="mb-3">
                  <label for="Number" class="form-label">Number</label>
                  <input
                    type="number"
                    class="form-control"
                    placeholder="User Number"
                    id="driverPhoneNumber"
                    v-model="this.basicInformation.mobile"
                  />
                </div>
                <div class="mb-3">
                  <label for="email" class="form-label">Email</label>
                  <input
                    type="email"
                    readonly
                    class="form-control"
                    placeholder="User email"
                    id="driverEmail"
                    v-model="this.basicInformation.email"
                  />
                </div>

                <div class="mb-3">
                  <label for="Address" class="form-label">Address</label>
                  <textarea
                    class="form-control"
                    placeholder="Write Here"
                    id="exampleFormControlTextarea1"
                    rows="1"
                    v-model="this.basicInformation.address"
                  ></textarea>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="submit"
                  class="btn btn-primary"
                  data-bs-dismiss="modal"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import http from '../../config/axios';
import userService from '../../config/axiosUserService';

export default {
  name: 'BasicInformation',
  props: ['alert', 'swal'],
  data() {
    return {
      personalInfo: [],
      errorMessage: '',
      basicInformation: {
        name: '',
        mobile: '',
        user_code: '',
        email: '',
        address: '',
        nid: ''
      },
      permission: ''
    };
  },
  mounted() {
    this.getPersonalInformation();
    this.permission = localStorage.getItem('userPermission').split(',');
  },
  methods: {
    getPersonalInformation() {
      // http.get('v3/partners/'+`${this.$route.params.id}`)
      userService
        .get(
          `v1/users?user_code=${this.$route.params.id}&fields=name,mobile,status,picture,nid,user_code,email,address`
        )
        .then((response) => {
          this.personalInfo = response.data.data;
          this.personalInfo.forEach((object) => {
            (this.basicInformation.name = object.name),
              (this.basicInformation.mobile = object.mobile),
              (this.basicInformation.email = object.email),
              (this.basicInformation.address = object.address),
              (this.basicInformation.user_code = object.user_code);
          });
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error('There was an error!', error);
        });
    },
    updateBasicInformation() {
      userService
        .post(`/v1/users/update/${this.$route.params.id}`, {
          address: this.basicInformation.address,
          name: this.basicInformation.name,
          email: this.basicInformation.email,
          mobile: this.basicInformation.mobile,
          user_code: this.basicInformation.user_code
        })
        .then((response) => {
          if (response.status === 200) {
            this.$swal('Submit!', response.data.message, 'success');
            this.getPersonalInformation();
            location.reload();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped>
.basic-info h5 {
  font-size: 18px;
  font-family: Montserrat;
  line-height: 14px;
  font-style: normal;
  font-weight: 600;
}

.basic-info span {
  font-size: 14px;
  font-family: Montserrat;
  font-weight: bold;
  text-decoration: none;
  line-height: normal;
}

.basic-info p {
  font-size: 12px;
  font-family: Montserrat;
}
</style>
